import type { PageTranslator } from '../types';
import React from 'react';
import Board from './PageBoard';
import { useTranslation } from 'react-i18next';
import { VOLUNTEERING_DISCLAIMER } from '@/modules/support/shared/volunteering-copy.ts';

export default function Volunteering() {
  const { t: rawT } = useTranslation(['pages', 'support']);
  const t = rawT as unknown as PageTranslator;

  return (
    <>
      <Board
        className="volunteer-header board-happyhippies"
        names="happyhippies"
      >
        <div className="container">
          <div className="row">
            <div className="col-xs-12 text-center">
              <br />
              <br />
              <i className="icon-3x icon-heart-o"></i>
              <br />
              <br />
              <h2>{t('Volunteering')}</h2>
            </div>
          </div>
        </div>
        <div></div>
      </Board>

      <section className="container container-spacer">
        <div className="row">
          <div className="col-xs-12 col-sm-offset-1 col-sm-10 col-md-offset-2 col-md-8">
            <p className="lead">
              {t(
                'Help us build Trustroots! Nobody can do everything, but everyone can do something…',
              )}
            </p>
            <p>{t(VOLUNTEERING_DISCLAIMER, { ns: 'support' })}</p>
            <p>
              {t(
                'Please head over to our Team Guide to learn how to get started.',
              )}
            </p>
            <ul className="list-inline">
              <li>
                <a
                  href="/support?category=volunteering"
                  className="btn btn-primary"
                >
                  {t('I’d like to help run Trustroots')}
                </a>
              </li>
              <li>
                <a href="https://team.trustroots.org/">{t('Team Guide')}</a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
